import Vue from 'vue'
import Router from 'vue-router'
import itemList from '@/views/itemMasterList'
import Item from '@/components/items/item'
import upload from '@/views/upload'
import groups from '@/views/groupBase'
import error404 from '@/views/errors/404'
const StoreItemRestrictions = () => import('@/views/StoreItemRestrictions.vue')
const Pricing = () => import('@/views/Pricing.vue')
const Price = () => import('@/views/Price.vue')

import { authGuard } from '@/auth/authGuard'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/items',
      meta: {
        requiresAuth: true,
        adminOnly: false
      }
    },
    {
      path: '/items',
      name: 'itemList',
      component: itemList,
      meta: {
        requiresAuth: true,
        title: 'Items',
        adminOnly: false
      }
    },
    {
      path: '/item-restrictions',
      name: 'itemRestrictions',
      component: StoreItemRestrictions,
      meta: {
        requiresAuth: true,
        title: 'Item Restrictions',
        adminOnly: false,
        requiresRestrictionManager: true
      }
    },
    {
      path: '/items/edit',
      name: 'item',
      component: Item,
      meta: {
        requiresAuth: true,
        adminOnly: false,
        title: 'Item'
      },
      props: true
    },
    {
      path: '/groups',
      name: 'groups',
      component: groups,
      meta: {
        requiresAuth: true,
        menuItem: true,
        menuName: 'Groups',
        title: 'Item Groups',
        adminOnly: false,
        app: 'items'
      },
      children: [
        {
          path: 'edit',
          name: 'groupEdit',
          component: groups,
          meta: {
            requiresAuth: true,
            title: 'Edit Group',
            adminOnly: false
          }
        },
        {
          path: 'new',
          name: 'groupNew',
          component: groups,
          meta: {
            requiresAuth: true,
            title: 'Create Group',
            adminOnly: false,
            requiresWriteAccess: true
          }
        }
      ]
    },
    {
      path: '*',
      name: '404',
      component: error404,
      meta: {
        requiresAuth: true,
        menuItem: false,
        title: '404 | iPro\u00AE Systems, LLC - Item Management',
        adminOnly: false,
        app: 'items'
      }
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: Pricing,
      meta: {
        requiresAuth: true,
        title: 'Pricing',
        adminOnly: true
      }
    },
    {
      path: '/price',
      name: 'Price',
      component: Price,
      meta: {
        requiresAuth: true,
        title: 'Price',
        adminOnly: true
      },
      props: true
    },
    {
      path: '/upload',
      name: 'DSD Upload',
      component: upload,
      meta: {
        requiresAuth: true,
        title: 'DSD Upload',
        adminOnly: false
      },
      props: true
    }
  ]
})

const guardOptions = {
  entities: ['item', 'item_group'],
  writeActions: ['create', 'read', 'update']
}

router.beforeResolve(async (to, from, next) => {
  if (to.hasOwnProperty('meta')) {
    // Use the route's "meta.title" value to assign the page's title
    if (to.meta.hasOwnProperty('title') && to.meta.title) document.title = to.meta.title
    // For routes requiring authentication ( has "meta.requiresAuth" property )
    if (to.meta.requiresAuth === true) {
      return authGuard(to, from, next, guardOptions)
    }
    return next()
  } else {
    return next()
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js